import _ from 'lodash';
import React from 'react';

import { Product } from '../types'; 
import { Helpers } from '../utils'; 
import getUpdatedProductState, {ProductState, UpdatedProductStateInput} from '../utils/attributesHelper'; 

interface useProductAttributesProps {
    attributes: Product.AvailableProductAttributes;
    variations: any
}
 
const initialStore: ProductState = {
    selected: [],
    available: {}
}

export const useProductAttributes = ({...props}: useProductAttributesProps) => {

    const [selectedVariation, setSelectedVariation] = React.useState<Product.ID>(0);
    const [store, setStore] = React.useState<ProductState>(initialStore);
    
    const attributes = React.useMemo(() => (
        // TODO: Leave this to backend
        // TODO: Check if in variations
        // NOTE: Revise this
        
        Object.fromEntries(Object.entries(props.attributes)
        .map(([name, attribute]: any, attrIndex) => {
            // If hidding avaialable enabled in config
            let availableOptionValues = Object.keys(attribute.options);
            // if ( true ) {
            //     availableOptionValues = availableOptionValues.filter(optionValue => {
            //         return true;
            //     })
            // }
            return [name, availableOptionValues];
        })
        )
    ), [props.attributes])
    
    const variations = React.useMemo(() => (
        // TODO: Sort variation atts by atts (to ensure same order)
        // TODO: Leave this to backend
        // TODO: Make conditional logic for filtering nonavailable configurable 
        Object.fromEntries(Object.entries(props.variations)
            .filter( ([id, variation]: any) => ['instock', 'onbackorder'].includes(variation.stockStatus) )
            .map(([id, variation]: any) => [id, Object.values(variation.attributes)]))  
    ), [props.variations]);
    
    React.useEffect(() => {
        if ( _.isEmpty( variations ) ) {
            return;
        }
        setStore( (prevState: ProductState) => {
            // TODO: Backend
            const initialVariationID: any = Number( Object.keys(variations)[0] );// NOTE: Find first available id
            const selected: any = Object.values(variations[initialVariationID]);
            
            const variationsAtts: any = Object.values(props.variations).filter((variation: any) => (variation.id in variations)).map((variation: any) => variation.attributes);
            const availableAttributes: any = {};

            variationsAtts.forEach((entry: any) => {
                for ( const [name, value] of Object.entries(entry) ) {
                    if ( ! (name in availableAttributes) ) {
                        availableAttributes[name] = [];
                    }
                    if ( ! availableAttributes[name].includes(value) ) {
                        availableAttributes[name].push(value);
                    }
                }
            });
            
            const { id, state } = getUpdatedProductState({prevState: {...prevState, selected, available: availableAttributes}, id: initialVariationID, attributes, variations});
            //const values = getUpdatedStore({prevState: {...prevState, selected}, id: selectedVariation, attributes, variations});
            
            setSelectedVariation(id);
            // NOTE: id may change, so what
            return state;
        })
        return () => {};
    }, [])

    const handleSelect = (updated: Product.AttributeSelected) => {
        // NOTE: Here is the issue origin probably as it is called always
        setStore( (prevState: ProductState) =>  {
            const { id, state } = getUpdatedProductState({prevState, updated, id: selectedVariation, attributes, variations});
            setSelectedVariation(id);
            //console.log('selected (old/new)', selectedVariation, id, updated);
            
            // NOTE: id may change, so what || why it returns state?! oh i know
            return {...state};
        })
    }

    return {id: selectedVariation, attributes: {...store}, handleSelect};

}